<template>
  <v-card
    class="mx-auto overflow-visible"
    width="255px"
    style="margin-top: 0px; margin-bottom: 0px"
    outlined
  >
    <div class="text-center custom-filter">
      <common-range-picker
        v-model="selectRange"
        :defaultRange="defaultRange"
        :clearable="true"
        :aLight="'left'"
        :noneMargin="true"
        formatdate="DD/MM/YYYY"
        class="disable-x"
        @change-date-range="changeDateRange"
      />
      <v-autocomplete
        :items="productGroups"
        item-text="name"
        item-value="_id"
        v-model="innerFilterForm.fanpage_id"
        placeholder="Tìm Fanpage"
        color="primary"
        class="custom-input mt-2"
        value=""
        clearable
        outlined
      />
      <v-autocomplete
        :items="listMarketer"
        item-text="fullName"
        item-value="id"
        multiple
        v-model="innerFilterForm.marketer_id"
        class="custom-input"
        placeholder="Tìm Marketer"
        color="primary"
        value=""
        clearable
        outlined
      />
      <v-text-field class="custom-input" v-model="innerFilterForm.master_id" placeholder="Tìm master_id" outlined  clearable/>
      <v-text-field
        class="custom-input"
        placeholder="Tìm content_id"
        v-model="innerFilterForm.content_id"
        outlined
        clearable
      />
      <v-text-field class="custom-input" v-model="innerFilterForm.ad_id" placeholder="Tìm ad_id" outlined  clearable/>
      <v-btn
        class="search-contact--text-oreange mx-0 my-2"
        small
        @click.prevent="handleSubmit()"
      >
        <v-icon>mdi-dropdown</v-icon>Tìm kiếm
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import * as moment from 'moment'
import RepositoryFactory from "@/repositories/RepositoryFactory";
const UserRepository = RepositoryFactory.get("user");
const ReportRepository = RepositoryFactory.get("report");

export default {
  props: {
    filterForm: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      defaultRange: {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      selectRange: [
        {
          startDate: moment().format("YYYY-MM-DD 00:00:00"),
          endDate: moment().format("YYYY-MM-DD 23:59:59"),
        },
      ],
      productGroups: [],
      listMarketer: [],
      innerFilterForm : {}
    };
  },
  async created() {
    await this.getListMarketer();
    await this.getListFanpage();
    this.innerFilterForm = _.cloneDeep(this.filterForm);


  },
  watch: {
    filterForm: {
      handler(val) {
        this.innerFilterForm = _.cloneDeep(val);
      },
      deep: true,
    },
    selectRange(val) {
      if(val) {
        this.innerFilterForm.date_from = val[0];
        this.innerFilterForm.date_to = val[1];
      }
    }
  },
  methods: {
    closeMenu() {
      this.$emit("closeMenu", false);
    },
    handleSubmit() {
      this.$emit("searchContent", this.innerFilterForm);
    },
    changeDateRange(dateRange) {
      this.selectRange = dateRange;
    },
    async getListFanpage() {
      const response = await ReportRepository.getListFanpage();
      if(response.data ) {
        this.productGroups = response.data;
      }
    },
    async getListMarketer() {
      const response = await UserRepository.listMarketer({identification:2});
      if(response.data ) {
        this.listMarketer = response.data;
      }
    },
  },
};
</script>
<style lang="scss">
.custom-input {
  .v-input__slot {
    min-height: 34px !important;
    // max-height: 34px !important;
  }
  .v-text-field__details {
    display: none !important;
  }
  .v-input__append-inner {
    margin-top: 5px !important;
  }
  .v-select__selections {
    padding: 0px !important;
  }
}
.disable-x {
  i.v-icon {
    display: none !important;
  }
}
</style>
<style lang="scss" scoped>
.custom-filter {
  border-radius: 7px;
  background: #fff;
  padding: 12px;
}
</style>